import { authHeader, handleResponse } from '../helpers';
import Vue from 'vue'

export const userService = {
    login,
    logout,
    register,
    getLoggedIn,
    getMenu,
    getAll,
    getById,
    update,
    delete: _delete,
    getSezone,
    getSheme
};


const sheme=[
{ime:"EKO PRI",icon:"tractor",
      ukazi:[
            {title:"Uredi",akcija:"pridelovalec",icon:"edit"},
            //{title:"Kulture",akcija:"kultura",icon:"seedling"},
            //{title:"Živali",akcija:"zival",icon:"horse-head"},
            {title:"Proizvodi",akcija:"proizvod",icon:"cheese"},
            {title:"Certifikati",akcija:"certifikat",icon:"certificate"},
            

            ]},
{ime:"EKO PRE",icon:"industry",
      ukazi:[
            {title:"Uredi",akcija:"pridelovalec",icon:"edit"},
            {title:"Proizvodi",akcija:"proizvod",icon:"cheese"},
            {title:"Certifikati",akcija:"certifikat",icon:"certificate"},
            ]},
{ime:"BREZ GSO",icon:"dna"},
{ime:"SENENO",icon:"wheat-awn"},
{ime:"IK"},
{ime:"IP"},
{ime:"GLOBALG.A.P."},
{ime:"PPR"},
{ime:"KOZMETIKA",icon:"paintbrush"},
{ime:"ZKPŽ"},
{ime:"DEMETER"},
{ime:"V-LABEL",icon:"seedling"}];



function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username:username, password:password })
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/user/login`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }

            return user;
        });
}

export function logout() {
    // return authorization header with jwt token
    localStorage.removeItem('user');
    localStorage.removeItem('userDetails');
    //
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/users/register`, requestOptions).then(handleResponse);
}

function getLoggedIn() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`${Vue.prototype.$config.apiUrl}/user`, requestOptions)
    .then(handleResponse)
    .then(user => {
           
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('userDetails', JSON.stringify(user));
           return user;
        })
    
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/users`, requestOptions).then(handleResponse);
}

function getSezone() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/user/sezone`, requestOptions).then(handleResponse);
}

function getSheme() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/stranke/shema`, requestOptions).then(handleResponse);
}


function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/users/${id}`, requestOptions).then(handleResponse);
}

function update(user) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/users/${user.id}`, requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/users/${id}`, requestOptions).then(handleResponse);
}


function getMenu(){

  const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/stranke/menu`, requestOptions).then(handleResponse);


/* var promise = new Promise(function(resolve, reject) {
  
    resolve(menuData);
  });

  return promise;

  */
}